import { DomElement, WebGLJson, WebGLRenderer } from 'THREE';

export const MaxRenderDistanceDefault = 1000;
export const MinRenderDistanceDefault = 0.1;
export const DefaultMaxRetry = 10;
export const DefaultMaxRetryInterval = 1500;

export enum Thumbnail3DTypes {
  avatarThumbnail = 'avatarThumbnail'
}

export interface ThumbnailRenderer {
  container: DomElement;
  renderer: WebGLRenderer;
}

export interface ThumbnailRenderers {
  [key: string]: ThumbnailRenderer;
}

export type ThumbnailCanvasSuccess = (canvas: DomElement) => void;

export type ThumbnailCanvasFail = () => void;

export type Thumbnail3DJsonFail = (error: string) => any;

export interface Thumbnail3DJsonUrlResponse {
  data: WebGLJson;
}

export interface Thumbnail3DJsonStats {
  realRegeneration: boolean;
  startTime: Date;
  retriesDone: number;
}

export interface Thumbnail3DJsonData {
  Url: string;
  Final: boolean;
}

export interface Thumbnail3DJsonResponse {
  data: Thumbnail3DJsonData;
}

export type Thumbnail3DJsonSuccess = (json: WebGLJson, stats: Thumbnail3DJsonStats) => any;
